/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum Examenstatus {
    GESLAAGD = "Geslaagd",
    AFGEWEZEN = "Afgewezen",
    VOORTIJDIG_TERUGGETROKKEN = "Voortijdig teruggetrokken",
    OVERIG = "Overig",
    TIJDENS_EXAMEN_TERUGGETROKKEN = "Tijdens examen teruggetrokken",
    VOORLAATSTE_JAAR = "Voorlaatste jaar",
    GESPREID_EXAMEN = "Gespreid examen",
    AANGEMELD = "Aangemeld"
}
